var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 5.45057C2.739 7.62305 4.46175 11.3047 7.99976 16C11.5378 11.3047 13.2607 7.62306 13.3332 5.45057H13.3301C13.332 5.39219 13.333 5.33357 13.333 5.27472C13.333 2.36157 10.9452 0 7.99976 0C5.05428 0 2.6665 2.36157 2.6665 5.27472C2.6665 5.33356 2.66748 5.39218 2.66941 5.45057H2.6665ZM7.99984 8.88889C9.96352 8.88889 11.5554 7.29701 11.5554 5.33333C11.5554 3.36965 9.96352 1.77778 7.99984 1.77778C6.03616 1.77778 4.44428 3.36965 4.44428 5.33333C4.44428 7.29701 6.03616 8.88889 7.99984 8.88889Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.b8141b475c5f1c347e258c41a2a65ca6.svg";
export { ForwardRef as ReactComponent };